import { ManagementPage } from "../components/common/ManagementPage";

const trailerFields = [
  { name: "trailer_number", label: "Trailer number", required: true, placeholder: "TR-53A" },
  { name: "trailer_type", label: "Trailer type", required: true, placeholder: "Dry Van" },
  { name: "plate_number", label: "Plate number", required: true, placeholder: "AB-TR101" },
  { name: "make", label: "Make", placeholder: "Great Dane" },
  { name: "model", label: "Model", placeholder: "Champion" },
  { name: "year", label: "Year", type: "number", min: "1990", step: "1", placeholder: "2021", parse: (value) => (value ? Number(value) : null) },
  { name: "vin", label: "VIN", placeholder: "1GDJS6345R1234567" },
  { name: "safety_expiration_date", label: "Safety expiration date", type: "date" },
  {
    name: "status",
    label: "Status",
    required: true,
    type: "select",
    options: [
      { label: "Active", value: "Active" },
      { label: "Maintenance", value: "Maintenance" },
      { label: "Inactive", value: "Inactive" },
    ],
  },
  { name: "notes", label: "Notes", type: "textarea", placeholder: "Maintenance or yard notes" },
];

export const TrailersPage = () => (
  <ManagementPage
    actionLabel="Add trailer"
    columns={[
      { key: "trailer_number", label: "Trailer #" },
      { key: "type", label: "Trailer type" },
      { key: "plate_number", label: "Plate" },
      { key: "vin", label: "VIN" },
      { key: "safety_expiration_date", label: "Safety expiry" },
      { key: "make", label: "Make" },
      { key: "year", label: "Year" },
      { key: "status", label: "Status" },
    ]}
    description="Track trailer VIN and safety expiry so dispatch can warn and block expired equipment before assignment."
    endpoint="/trailers"
    entityName="Trailer"
    fields={trailerFields.map((field) => (field.name === "trailer_type" ? { ...field, name: "type" } : field))}
    title="Trailers"
  />
);